import { PublicClientApplication } from "@azure/msal-browser";
import appconfig from "./_Services/appconfig.js";

const msalConfig = {
  auth: {
    clientId: appconfig.entraid_clientId,
    authority: appconfig.entraid_authority,
    redirectUri: appconfig.entraid_redirectUri, 
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
